import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import SearchSvg from '../../svg/admin/Search';
import MoreSvg from '../../svg/admin/More';
import PageSelector from '../components/PageSelector';
import { fetchSchoolMissions, teacherUpdateSchoolMission } from '../../services2/schoolMissions.service';
import { useSetting } from '../../util/useSetting';
import DropDownSelection from './components/DropDownSelection';

const temp = [
    {
        id: '1',
        name: '托物言志',
        subtitle: '〈愛蓮說〉｜',
        subtitle2:'〈醜石〉',
        image: '/secondary/temp/1.png'
    }, {
        id: '2',
        name: '借事說理',
        subtitle: '〈傷仲永〉｜',
        subtitle2:'〈習慣說〉',
        image: '/secondary/temp/2.png'
    },
    {
        id: '3',
        name: '平淡之宗',
        subtitle: '〈桃花源記〉｜',
        subtitle2:'〈歸園田居〉',
        image: '/secondary/temp/3.png'
    },
    {
        id: '4',
        name: '唐詩氣象',
        subtitle: '〈月下獨酌（其一）〉｜',
        subtitle2:'〈山居秋暝〉｜',
        subtitle3:'〈登樓〉',
        image: '/secondary/temp/4.png'
    },
    {
        id: '5',
        name: '孔孟之道',
        subtitle: '〈論仁、論孝、論君子〉｜',
        subtitle2:'〈魚我所欲也〉',
        image: '/secondary/temp/5.png'
    }
]

function Component(props) {
    const { } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const id = searchParams.get('id')||null
    const [data, setdata] = useState(null)
    const [isLoading, setisLoading] = useState(true)
    const [total, settotal] = useState(0)
    const { fontSize } = useSetting();


    const filter = searchParams.get('filter') || '全部';
    const status = searchParams.get('status') || '全部';
    const page = parseInt(searchParams.get('page')) || 1;
    const limit = 10
    const totalPage = Math.ceil(total / limit) || 1

    const handleSelectPage = (p) => async () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    const handleUpdateStatus = (newValue) => {
        searchParams.delete('status')
        searchParams.set('status', newValue)
        setSearchParams(searchParams)
    }

    const fetchData = async (force = false) => {
        if (isLoading && !force) return
        setisLoading(true)
        const filter = {}
        // if (status !== '全部') filter.status = status
        let result = await fetchSchoolMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        if (result.result) {
            setdata(result.result)
            settotal(result.count || 0)
        } else {
            alert('Fetch data error')
        }
        setisLoading(false)
    }



    useEffect(() => {
        const timer = setTimeout(()=>{fetchData(true)}, 500)
        // const interval = setInterval(fetchData,1000*30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])



    const [isViewMissionDetails, setIsViewMissionDetails] = useState(null)

    useEffect(() => {
        if (id) {
            const mission = data?.find(item => item._id === id)
            if (mission) setIsViewMissionDetails(mission)
        }
    }, [id, data])

    if (isViewMissionDetails) return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex gap-[16px] overflow-auto pb-[24px]' style={{ fontSize }}>
            <div className='w-full flex flex-row justify-start p-[16px]'>
                <button className='text-[#4B555C] font-bold' onClick={() => {
                    setIsViewMissionDetails(null);
                    navigate(`/platform2/missions`)
                }}>{'< 返回單元總覽'}</button>
            </div>

            <div className='relative w-full flex flex-col p-[16px] font-bold overflow-auto' style={{ minHeight: '400px', backgroundImage: `url(${isViewMissionDetails?.mission.photo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                <div className='absolute bottom-0 left-0 right-0 h-[50%] z-[1]' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1), rgba(0,0,0,0))' }} />
                <div className='flex flex-row gap-[16px] z-[2]'>
                    <div style={{ fontWeight: 900, fontSize: fontSize + 4 }}>{isViewMissionDetails?.mission?.name}</div>
                    <div className='text-[#7A685B] mt-[8px]' style={{ fontWeight: 'bold' }}>{isViewMissionDetails?.mission?.pages?.map(page => "〈" + page.name + '〉').join(' | ')}</div>
                </div>
                <div className='flex flex-row items-center justify-start gap-[16px] z-[2] mt-[24px]' style={{}}>
                    <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>
                        {isViewMissionDetails.mission?.categories[0]}
                    </div>
                    <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96' }}>
                        {isViewMissionDetails.mission?.categories[1]}
                    </div>
                </div>
                <div className='flex-1 flex flex-col justify-end mt-[24px] w-full z-[2]'>
                    <div className='text-[#003A57] font-[900] w-full flex flex-col items-center' style={{border:'2px solid white', borderRadius:'8px',backdropFilter:'blur(8px)'}}>
                        <div className='w-full text-center p-[8px]' style={{borderBottom:'2px solid white', borderRadius:'8px',fontSize: fontSize + 4}}>單元簡介</div>
                        <div className='p-[16px] font-[700] noto-san-hk text-black' style={{textAlign:'justify'}}>{isViewMissionDetails?.mission?.description}</div>
                    </div>
                </div>
            </div>

            <div className='w-full px-[16px]'>
                <div className='flex-1 flex flex-col justify-end mt-[24px] w-full z-[2] items-center'>
                    <div className='text-[#003A57] font-[900] w-full flex flex-col items-center px-[16px]' style={{border:'2px solid white', borderRadius:'8px',backdropFilter:'blur(8px)',background:'linear-gradient(to bottom, #ffffff88, #ffffff00)'}}>
                        <div className='w-full text-center p-[8px]' style={{fontSize: fontSize + 4}}>拓展閱讀概覽</div>
                        <div className='w-full flex flex-col rounded-[8px]' style={{border:'1px solid #A6A6A6',}}>
                            <div className='w-full flex flex-row p-[8px] text-white' style={{background: 'linear-gradient(to right, #34778C, #63BBD1)'}}>
                                <div className='flex-1 text-center'>核心問題</div>
                                <div className='flex-1 text-center'>拓展篇章</div>
                            </div>
                            {isViewMissionDetails?.mission?.pages?.map((page, index) => (
                                <div key={index} className='w-full flex flex-row px-[8px] items-stretch noto-san-hk text-black font-bold' style={{borderBottom: '1px solid #A6A6A6'}}>
                                    <div className='flex-1 text-left flex text-left items-center p-[8px]' style={{borderRight: '1px solid #A6A6A6'}}>
                                        {page.core_questions?.map(q=>q.question).join(' ')}
                                    </div>
                                    <div className='flex-1 text-left p-[8px]' style={{whiteSpace: 'pre-line'}}>
                                        {page?.category}
                                        <br/>
                                        {page.articles?.map((a,i)=>'篇章' + (i === 0 ? '一' : i === 1 ? '二' : i === 2 ? '三' : i === 3 ? '四' : i === 4 ? '五' : i + 1) + ': ' + a.name).join('\r\n')}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className='w-full text-center p-[8px] my-[16px]' style={{fontSize: fontSize + 4}}>教學藍圖</div>
                        <div className='w-[90%] flex justify-center items-center mb-[24px]'>
                            <div className='w-[90%] flex justify-center items-center mb-[24px] relative'>
                                <img src={'/secondary/tasks/task1_.png'} alt="教學藍圖" className='w-full max-w-[1400px]' />
                                <button className='absolute w-[20%] h-[37%] top-[64%] left-[10.5%] bg-[#ffffff00] opacity-50' onClick={() => { navigate(`/platform2/missions/${isViewMissionDetails?._id}?session=電子書 1`) }}></button>
                                <button className='absolute w-[10%] h-[28%] top-[68%] left-[31.4%] bg-[#ffffff00] opacity-50' onClick={() => { navigate(`/platform2/missions/${isViewMissionDetails?._id}?session=電子書 1`) }}></button>
                                <button className='absolute w-[20%] h-[37%] top-[64%] left-[46.4%] bg-[#ffffff00] opacity-50' onClick={() => { navigate(`/platform2/missions/${isViewMissionDetails?._id}?session=電子書 2`) }}></button>
                                <button className='absolute w-[10%] h-[28%] top-[68%] left-[67%] bg-[#ffffff00] opacity-50' onClick={() => { navigate(`/platform2/missions/${isViewMissionDetails?._id}?session=電子書 2`) }}></button>
                                <button className='absolute w-[14%] h-[36%] top-[25%] left-[84%] bg-[#ffffff00] opacity-50' onClick={() => { navigate(`/platform2/missions/${isViewMissionDetails?._id}?session=單元習題`) }}></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*image*/}
        </div>
    )
    return (
        <div className='h-full flex-1 bg-[#EDF5F8] flex-col flex p-[16px] gap-[16px] pb-[36px]' style={{ fontSize  }}>
            {/*title, filter, serach box*/}
            <div className='p-[16px] flex flex-col items-start justify-start gap-[16px]'>
                <div className='text-[#4B555C] font-[700] '>單元總覽</div>
                <DropDownSelection  color='#007A83' value={status} options={['全部', '啟動中', '開發中']} onUpdate={handleUpdateStatus} />  
            </div>
            {/*end of title, filter, serach box*/}

            {/*list of data*/}
            <div className='flex flex-col flex-1 w-full px-[16px] justify-start items-start  overflow-auto gap-[8px]'>
                {/* {data?.map((item, index) =>
                    <div key={item?._id} className='relative flex-1 max-w-[50%] flex flex-col p-[16px] rounded-[16px] w-[50%] font-bold overflow-hidden' style={{ height: undefined, aspectRatio: 763 / 382, backgroundImage: `url(${item?.mission.photo})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
                        <div className='absolute bottom-0 left-0 right-0 h-[50%] z-[1]' style={{ background: 'linear-gradient(to top, rgba(255,255,255,1), rgba(0,0,0,0))' }} />

                        <div className='flex flex-row items-center justify-start gap-[16px] z-[2]' style={{}}>
                            <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'linear-gradient(to right, #003A57, #108B96)', color: 'white' }}>
                                {item.mission?.categories[0]}
                            </div>
                            <div className='px-[16px] rounded-full py-[4px] font-bold' style={{ background: 'white', color: '#108B96' }}>
                                {item.mission?.categories[1]}
                            </div>
                        </div>
                        <div className='flex flex-col justify-end flex-1 z-[2]'>

                            <div className='flex flex-row w-full items-center text-[#005B8C] gap-[16px]'>
                                <div className='flex flex-col'>
                                    <div style={{ fontWeight: 900, fontSize: fontSize + 4 }}>{item?.mission?.name}</div>
                                    <div className='text-[#7A685B] mt-[8px]' style={{ fontWeight: 'bold' }}>{item?.mission?.pages?.map(page => "〈" + page.name + '〉').join(' | ')}</div>
                                </div>
                                <div className='flex-1 flex flex-row justify-end'>
                                    <button onClick={() => setIsViewMissionDetails(item)}  className='text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                                      <div className='rounded-full px-[20px] py-[6px] ' style={{border:'2px solid #eee',background:'linear-gradient(to right, #015B6B, #00E9BA)'}}>
                                      {'繼續單元 >'}
                                      </div>
                                  </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )} */}
                <div className='w-full p-[8px] flex flex-row gap-[12px] items-center justify-start font-bold noto-san-hk pb-[18px]' style={{}}>
                    <div style={{ width: '108px'}}>單元</div>
                    <div className='text-black opacity-[0]' style={{fontSize: fontSize + 6}}>天下襟懷</div>
                    <div className='text-black flex-[3]'>篇目</div>
                    <div className='text-black flex-[5]'>核心問題</div>
                    <div className='text-black flex-[5]'>核心問題 II</div>
                    <div  className='ml-[24px] w-[150px]'>
                    </div>
                </div>
                {data?.map((item, index) =>
                    <div key={item?._id} className='w-full p-[8px] rounded-[10px] flex flex-row gap-[12px] items-center justify-start' style={{boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', background:'linear-gradient(to bottom, #ffffff, #F0FBFF)'}}>
                        <img src={item?.mission?.photo} alt={item?.mission?.name} style={{ width: '108px', height: '86px', objectFit: 'cover', borderRadius: '10px' }} />
                        <div className='text-[#003A57] font-[900]' style={{fontSize: fontSize + 6}}>{item?.mission?.name}</div>
                         <div className='text-black flex-[3]'>
                            〈{item?.mission?.pages[0]?.name}〉|
                            <br/>
                            〈{item?.mission?.pages[1]?.name}〉
                        </div>
                        <div className='text-black flex-[5]'>{item?.mission?.pages?.[0]?.core_questions?.map(question => question.question).join(' ')}</div>
                        <div className='text-black flex-[5]'>{item?.mission?.pages?.[1]?.core_questions?.map(question => question.question).join(' ')}</div>
                        <button onClick={() => setIsViewMissionDetails(item)}  className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #015B6B, #00E9BA)' }}>
                            <div className='rounded-full px-[20px] py-[6px] ' style={{border:'2px solid #eee',background:'linear-gradient(to right, #015B6B, #00E9BA)'}}>
                            {'繼續單元 >'}
                            </div>
                        </button>
                    </div>
                )}
                 {data&&temp?.map((item, index) =>
                    <div key={item.id} className='w-full p-[8px] rounded-[10px] flex flex-row gap-[12px] items-center justify-start' style={{boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)', background:'linear-gradient(to bottom, #ffffff, #F0FBFF)'}}>
                        <img src={item?.image} alt={item?.name} style={{ width: '108px', height: '86px', objectFit: 'cover', borderRadius: '10px' }} />
                        <div className='text-[#003A57] font-[900]' style={{fontSize: fontSize + 6}}>{item?.name}</div>
                        <div className='text-black flex-[3]'>{item?.subtitle}<br/>{item?.subtitle2}<br/>{item?.subtitle3||''}</div>
                        <div className='text-black flex-[5]'>{'開發中'}</div>
                        <div className='text-black flex-[5]'>{'開發中'}</div>
                        <button onClick={() => alert('開發中')}  className='w-[150px] text-[#007A83] font-bold mb-[6px] mr-[8px] noto-san-hk text-white p-[2px] rounded-full' style={{ fontSize: fontSize - 2, background: 'linear-gradient(to left, #BEBEBE80, #F0FBFF)' }}>
                            <div className='rounded-full px-[20px] py-[6px] ' style={{border:'2px solid #eee',background:'linear-gradient(to right, #BEBEBE80, #F0FBFF)'}}>
                            {'繼續單元 >'}
                            </div>
                        </button>
                    </div>
                )}
            </div>
            {/*end of list of data*/}
            <PageSelector
                handleSelectPage={handleSelectPage}
                page={page}
                total={total}
                totalPage={totalPage}
            />
            {isLoading && <LoadingPage />}
        </div>
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
